import { CarPdfChart } from "@app/components/PdfChart";
import { CSSProperties } from "react";
import { CarPortfolioAssetRow } from "../usePortfolioGroupVersionData";

interface ModuleChartItem {
  label: string;
  value: number;
  color: CSSProperties["color"];
}

interface AssetAllocationModulePdfPieChartProps {
  size: number;
  rows: CarPortfolioAssetRow[];
  moduleId: string;
  dataId?: string;
}

export const AssetAllocationModulePdfPieChart = (
  props: AssetAllocationModulePdfPieChartProps,
) => {
  const data = props.rows
    .map<ModuleChartItem>((row) => ({
      label: row.name,
      color: row.color,
      value:
        row.modules
          .find((mod) => mod.moduleId === props.moduleId)
          ?.values.find((val) => val.dataId === props.dataId)?.allocation ?? 0,
    }))
    .filter((i) => i.value > 0);

  if (data.length === 0) {
    data.push({ label: "", value: 1, color: "#B2B3B5" });
  }

  return (
    <CarPdfChart
      type="pie"
      width={props.size}
      height={props.size}
      options={{}}
      data={{
        labels: data.map((i) => i.label),
        datasets: [
          {
            label: "data",
            data: data.map((i) => i.value),
            backgroundColor: data.map((i) => i.color),
            borderWidth: 0,
          },
        ],
      }}
    />
  );
};
